import { pgTable, serial, text, integer, timestamp } from "drizzle-orm/pg-core";
import { createInsertSchema } from "drizzle-zod";
import { z } from "zod/v4";

export const tenderNotesTable = pgTable("tender_notes", {
  id: serial("id").primaryKey(),
  tenderId: integer("tender_id").notNull(),
  userId: integer("user_id").notNull(),
  authorName: text("author_name").notNull(),
  content: text("content").notNull(),
  mentions: text("mentions").array(),
  createdAt: timestamp("created_at").notNull().defaultNow(),
  updatedAt: timestamp("updated_at").notNull().defaultNow(),
});

export const insertTenderNoteSchema = createInsertSchema(tenderNotesTable).omit({ id: true, createdAt: true, updatedAt: true });
export type InsertTenderNote = z.infer<typeof insertTenderNoteSchema>;
export type TenderNote = typeof tenderNotesTable.$inferSelect;
